/* eslint-disable max-lines */
import React, { useEffect } from 'react';

// navigation
import { useNavigate } from 'react-router-dom';
import ForgotPasswordLink from './ForgotPasswordLink';
import { useEmailPagePath } from '../../../navigation';

// context, state and remote data
import useTrackPageShown from 'src/viewLayer/components/hooks/useTrackPageShown';

// view components
import CardLayout from './../CardLayout';
import PasswordImage from './Images/Password.svg';
import KeysImage from './Images/Keys.svg';
import BigLockImage from './Images/BigLock.svg';
import PasswordInput from 'src/viewLayer/components/shared/Inputs/PasswordInput';
import useToggleVisibility from 'src/viewLayer/components/hooks/useToggleVisibility';
import TrackableButton from '../../shared/TrackableButton';
import BackButton from '../BackButton';
import ChangeEmailLink from 'src/viewLayer/components/shared/HintLinks/ChangeEmailLink';
import './index.scss';

import { t } from 'src/viewLayer/helpers/translations';

export default function LoginPasswordPage({
  appType,
  path,
  password,
  errorKey,
  isFocused,
  setFocus,
  email,
  captchaFeature,
  captchaComplete,
  inProgress,
  onChange,
  onSubmit
}) {
  const navigate = useNavigate();
  const [isVisible, toggleVisibility] = useToggleVisibility(false);
  const emailPagePath = useEmailPagePath();
  useTrackPageShown({ appType, pageType: path });
  useEffect(() => {
    if (!email) navigate(emailPagePath, { replace: true });
  }, [email, emailPagePath, navigate]);
  const setVisibility = () => {
    toggleVisibility();
    setFocus(true);
  };

  return (
    <div className="LoginPasswordPage">
      <CardLayout
        title={ t('password.title') }
        subtitle={ email }
        Image={ PasswordImage }
        BackgroundItems={ [KeysImage, BigLockImage] }>
        <ChangeEmailLink />
        <BackButton trackingId="backbutton-password-to-email" path={ path }/>
        <form onSubmit={ onSubmit }>
          <PasswordInput
            errorKey={ errorKey }
            isFocused={ isFocused }
            setFocus={ setFocus }
            onChangeHandler={ onChange }
            toggleVisibility={ setVisibility }
            isVisible={ isVisible }
            value={ password }
            disabled={ inProgress } />
          <ForgotPasswordLink/>
          { captchaFeature }
          <div className="actions">
            <TrackableButton
              disabled={ password.length === 0 || inProgress || !captchaComplete }
              inProgress={ inProgress }
              trackingId="password_submit">
              { t('password.button.login') }
            </TrackableButton>
          </div>
        </form>
      </CardLayout>
    </div>
  );
};
